import { AppBar, Button, CardMedia, CircularProgress, Paper, Typography, useTheme } from "@mui/material";
import { Footer } from "../components/commonComponents";
import { Box, Stack } from "@mui/system";
import { useHistory } from 'react-router';

function OnboardingConsentLoading(): JSX.Element {
    const theme = useTheme();
    const history = useHistory();
    return (
        <Stack
            sx={{
                minHeight: '100vh',
                // background: '#f2f6f8 url("/images/abcl-newbg.svg")',
                backgroundImage: 'url("/images/abcl-newbg.svg")',
                repeat: 'no-repeat',
                backgroundSize: 'cover',
            }}
        >
            <AppBar elevation={0} position="static" sx={{ bgcolor: 'transparent' }}>
                <Box>
                    <CardMedia
                        component="img"
                        onClick={() => history.push('/')}
                        src="/images/abcl-wealth-logo.svg"
                        alt="Logo"
                        sx={{
                            margin: "15px 0px 0px 15px",
                            cursor: 'pointer',
                            width: '12rem',
                        }}
                    />
                </Box>
            </AppBar>

            <Box
                component="main"
                sx={{
                    flex: 1,
                    display: 'grid',
                    placeItems: 'center',
                    padding: '15px',


                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        maxWidth: 600,
                        width: '100%',
                        borderRadius: '16px',
                        textAlign: 'center',
                        backgroundColor: 'background.default',
                    }}
                >
                    <CircularProgress />
                </Paper>

            </Box>
            <Footer />
        </Stack>
    );
}

export default OnboardingConsentLoading;